import React, { useState, useEffect } from 'react';
import { Card } from '../../components/ui/card';
import Sidebar from './components/Sidebar';
import HeaderSection from './components/HeaderSection';
import GettingStartedSection from './components/GettingStartedSection';
import ApiReferenceSection from './components/ApiReferenceSection';
import GitHubIntegrationSection from './components/GitHubIntegrationSection';
import { sections } from './constants';

const DocsPage = () => {
  const [activeSection, setActiveSection] = useState('getting-started');
  
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 100 && rect.bottom >= 100) {
          setActiveSection(section.getAttribute('data-section'));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.querySelector(`[data-section="${sectionId}"]`);
    if (element) {
      const offset = element.offsetTop - 80;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar 
        sections={sections} 
        activeSection={activeSection} 
        onSectionClick={scrollToSection} 
      />
      
      <div className="flex-1">
        <div className="max-w-5xl mx-auto px-6 py-12">
          <HeaderSection />
          <GitHubIntegrationSection />
          <GettingStartedSection />
          <ApiReferenceSection />
        </div>
      </div>
    </div>
  );
};

export default DocsPage;